import { EAppointmentStatus, IAppointment } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";
import { useGetRescheduleAppointmentEligibility } from "@modules/eirCustomersFacade/swr";
import { useDeviceType } from "@hook/useDeviceType";
import { useContext, useEffect } from "react";
import { HomeContext } from "@context/HomeContext";

export const useAppointmentBanner = (appointment: IAppointment) => {
    const shouldCheckEligibility = appointment.status !== EAppointmentStatus.LOCKED;
    const { data: eligibility } = useGetRescheduleAppointmentEligibility(appointment.id, shouldCheckEligibility);
    const { isMobile } = useDeviceType();
    const { updateBackgroundHeight } = useContext(HomeContext);
    const showButton = shouldCheckEligibility && eligibility?.isEligible;

    useEffect(() => {
        if (showButton && updateBackgroundHeight) {
            updateBackgroundHeight();
        }
    }, [showButton, updateBackgroundHeight]);

    return {
        isMobile,
        showButton,
    };
};
